// Reads the current guest's first name and avatar URL out of localStorage.
// Colocated as a hook so `GuestMapPage` can stay free of JSON parsing
// boilerplate. Runs once at mount — the values are cached in useMemo and
// intentionally don't react to localStorage writes, matching the previous
// inline behaviour.

import { useMemo } from 'react';
import { resolveAvatarUrl } from '../utils/resolveAvatarUrl';

export function useLocalUserProfile() {
  const firstName = useMemo(() => {
    try {
      const u = JSON.parse(localStorage.getItem('user') || '{}');
      return (u?.name || u?.username || '').split(' ')[0] || 'there';
    } catch { return 'there'; }
  }, []);
  const userAvatarUrl = useMemo(() => {
    try {
      const u = JSON.parse(localStorage.getItem('user') || '{}');
      return resolveAvatarUrl(u?.photo_url) || null;
    } catch { return null; }
  }, []);
  return { firstName, userAvatarUrl };
}
